<template>
  <div class="box">
    <img :src="getImg(team.badge)" />
    <div class="name">{{ team.name }}</div>
    <div v-if="receive">
      <div style="border-bottom: 1px solid #000;padding: 0 12px 12px 12px;">“{{ team.name }}”邀请您成为领队<br />参加“{{ match.unionMatchName }}/{{ match.matchGroupName }}”的比赛</div>
      <input type="text" v-model="transferCode" placeholder="请输入随机码">
      <div class="button" @click="confirm">确认移交</div>
    </div>
    <div v-else>
      <div>移交验证码</div>
      <div class="code" @click="copy">{{ code }}</div>
      <div class="ts">领队移交时，需要接收方输入验证码，验证成功后可移交球队。本次i操作具有一定风险，请妥善保存验证码</div>
      <div class="button" @click="share(true)">邀请接收球队</div>
    </div>
    <ShareLayer :shareShow="shareShow" @close="shareShow = false"></ShareLayer>
  </div>
</template>

<script>
import { QNImageUtil } from "@/utils";
import { getTeamLeaderTransferCode, getBMMatchTeamSignup, claimTeamTransfer } from "@/api/match";
import Vue from 'vue';
import { Toast } from 'vant';
Vue.use(Toast);
import ShareLayer from "@/components/ShareLayer"
export default {
  components: {
    ShareLayer
  },
  data() {
    return {
      matchId: '',
      teamId: '',
      team: {},
      match: {},
      code: '',
      transferCode: '',
      shareShow: false,
      receive: false
    };
  },
  created() {
    if (this.$route.query.receive === 'receive') {
      this.receive = true
    }
  },
  mounted() {
    this.matchId = this.$route.query.matchId
    this.teamId = this.$route.query.teamId
    this.getBMMatchTeamSignup()
    if (!this.receive) {
      this.getTeamLeaderTransferCode()
    }
  },
  methods: {
    getImg(img) {
      return QNImageUtil.imageView(img, 120, 120)
    },
    getBMMatchTeamSignup() {
      const params = {
        matchId: this.matchId,
        teamId: this.teamId
      }
      getBMMatchTeamSignup(params).then(res => {
        const { data } = res
        this.team = data.team
        this.match = data.match
        document.title = data.match.unionMatchName
        this.share(false)
      })
    },
    getTeamLeaderTransferCode() {
      const params = {
        matchId: this.matchId,
        teamId: this.teamId
      }
      getTeamLeaderTransferCode(params).then(res => {
        const { data } = res
        this.code = data.transferCode
      })
    },
    copy() {
      navigator.clipboard.writeText(this.code);
      Toast('复制成功！')
    },
    share(is) {
      const shareObj = {
        title: `${this.team.name}邀请您接管球队`,
        abstract: `${this.match.unionMatchName}/${this.match.matchGroupName}的${this.team.name}邀请您接管球队`,
        link: process.env.VUE_APP_BM_MATCH + '#/entry-page/transfer-captain?matchId=' + this.matchId + '&teamId=' + this.teamId + '&receive=receive',
        image: this.team.badge ? QNImageUtil.imageView(this.team.badge) : ''
      }
      this.wxShare(shareObj)
      this.shareShow = is
    },
    confirm() {
      const params = {
        matchId: this.matchId,
        teamId: this.teamId,
        transferCode: this.transferCode,
      }
      claimTeamTransfer(params).then(res => {
        if (res) {
          Toast('移交成功！')
          this.$router.push(`/entry-page/entry-list?unionMatchId=${this.match.unionMatchId}`)
        }
      })
    }
  },
};
</script>

<style scoped lang="scss">
.box {
  text-align: center;
  padding: 0 14px;
  padding-top: 66px;

  img {
    border-radius: 50%;
  }
  input{
    margin-top: 32px;
    width: 80%;
    font-size: 16px;
    text-align: center;
    padding: 8px;
    margin-bottom: 66px;
  }

  .name {
    margin: 18px 0 34px 0;
  }

  .code {
    border-bottom: 2px solid #000;
    padding-top: 22px;
    padding-bottom: 12px;
    color: #A4252A;
    // font-weight: 600;
    font-size: 22px;
  }

  .ts {
    margin-top: 16px;
    font-size: 14px;
    color: #222;
    margin-bottom: 44px;
  }

  .button {
    background-color: #002A9D;
    color: #fff;
    width: 95%;
    padding: 14px 0;
    display: inline-block;
    border-radius: 30px;
    font-size: 14px;
  }
}
</style>
